import React from 'react'
import "./InputComponent.scss"
const InputComponent = ({ placeholder, value, onChange, layout = "layout1", type = "text", isError = false, errorMessage = "", disabled, required = false }) => {


    return (
        <div className='InputComponent-Wrapper'>
            <div className={`InputComponent-${layout}  ${isError ? "InputComponent-error" : ""} ${disabled ? "InputComponent-disabled" : ""}`}>
                <input placeholder={`${placeholder || ""}${required ? "*" : ""}`}
                    value={value} onChange={onChange} type={type}
                    disabled={disabled}
                />
            </div>
            {isError && <div className='InputComponent-error'>{errorMessage}</div>}
        </div>

    )
}
export default InputComponent